<script>
    export default {
        data() {
            return {
                tabs: [],
                currentTabHeight: "0px",
                currentTabOverflow: "visible",
                animationTimeout: null
            };
        },
        created() {
            this.tabs = this.$children;
        },
        mounted() {
            if(window.location.hash) {
                this.selectTab(window.location.hash)
            } else {
                let selectedTab = this.tabs.find(tab => tab.selected)
                if(selectedTab) {
                    this.selectTab(selectedTab);
                } else {
                    this.selectTab(0);
                }
            }
        },
        methods: {
            selectTab(selectedTab) {
                if(typeof selectedTab === "number") {
                    selectedTab = this.tabs[selectedTab];
                } else if (typeof selectedTab === "string") {
                    selectedTab = {name: selectedTab};
                }

                const prevtab = this.tabs.find(tab => tab.isActive);

                if(prevtab) {
                    this.currentTabHeight = prevtab.$el.offsetHeight + "px";
                }

                this.tabs.forEach(tab => (tab.isActive = false));

                const tabToSelect = this.tabs.find(tab => ((tab.href === selectedTab.name) || (tab.name === selectedTab.name))) || this.tabs[0];

                if(tabToSelect) {
                    tabToSelect.isActive = true;
                    this.$nextTick(() => {
                        this.currentTabHeight = tabToSelect.$el.offsetHeight + "px";
                        this.currentTabOverflow = "hidden";

                        if(this.animationTimeout) {
                            clearTimeout(this.animationTimeout);
                        }

                        this.animationTimeout = setTimeout(() => {
                            this.currentTabHeight = "auto";
                            this.currentTabOverflow = "visible";
                        }, 600);
                    })

                    this.$emit("tabChanged", tabToSelect);
                }
            }
        }
    }
</script>

<template>
    <div class="f9tabs">
        <div class="tabs">
            <ul>
                <li v-for="(tab, index) in tabs" :key="index" :class="{ 'is-active': tab.isActive }">
                    <a :href="tab.href" aria-role="tab" :aria-label="tab.name + ' tab'" @click="selectTab(tab)">{{ tab.name }}</a>
                </li>
            </ul>
        </div>
        <div class="tabs-details" :style="{ height: currentTabHeight, overflow: currentTabOverflow }">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="less" scoped>
    @import "~less-variables";
    .f9tabs {
        .tabs {
            -webkit-overflow-scrolling: touch;
            -webkit-touch-callout: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            -webkit-box-align: stretch;
            -ms-flex-align: stretch;
            align-items: stretch;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            font-size: 1rem;
            -webkit-box-pack: justify;
            -ms-flex-pack: justify;
            justify-content: space-between;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;

            ul {
                list-style: none;
                margin: 0;
                padding: 0;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-flex: 1;
                -ms-flex-positive: 1;
                flex-grow: 1;
                -ms-flex-negative: 0;
                flex-shrink: 0;
                -webkit-box-pack: start;
                -ms-flex-pack: start;
                justify-content: flex-start;

                li {
                    line-height: 20px;
                    font-size: 16px;
                    font-weight: 400;
                    border-color: @white;
                    border-style: solid;
                    border-width: 0 4px 4px 4px;
                    flex: 1;

                    &:first-of-type {
                        border-left: 0;
                    }
                    
                    &:last-of-type {
                        border-right: 0;
                    }
                    
                    &:after {
                        content: "";
                        opacity: 0;
                        display: block;
                        transition: opacity 0.6s;
                    }

                    &.is-active {
                        border: 0;

                        a {
                            background: @ibe-background--bluegray radial-gradient(circle, transparent 1%, @ibe-background--bluegray 1%) center/15000%;
                            transition: background 0.8s;
                            font-weight: 600;
                            height: 54px;
                            cursor: default;
                        }

                        &:after {
                            content: "";
                            display: block;
                            height:5px; 
                            width:100%;
                            opacity: 1;
                            background-image: linear-gradient(87deg, #006643 0%, #00acec 100%);
                        }
                    }

                    &:not(.is-active) {
                        a {
                            &:hover {
                                background-color: #627c86;
                            }
                        }
                    }

                    a {
                        cursor: pointer;
                        text-decoration: none;
                        color: @white;
                        background: #556c75;
                        background-size: 100%;
                        height: 55px;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-pack: center;
                        -ms-flex-pack: center;
                        justify-content: center;
                        margin-bottom: -1px;
                        padding: .5em 1em;
                        vertical-align: top;
                        background-position: center;
                        transition: background 0s;
                    }
                }
            }

            
        }

        .tabs-details {
            background-color: #576e77;
            transition: height .5s;
            height: auto;
        }
    }

    @media @tablet-lg {
        .f9tabs {
            .tabs {
                ul {
                    li {
                        font-size: 12px;

                        a {
                            height: 50px;
                        }

                        &.is-active {
                            a {
                                height: 50px;
                            }
                        }

                    }
                }

                
            }
        }
    }

    @media @tablet {
        .f9tabs {
            .tabs {
                ul {
                    li {
                        font-size: 11px;

                        a {
                            height: 45px;
                        }

                        &.is-active {
                            &:after {
                                height:4px; 
                            }
                            a {
                                height: 45px;
                            }
                        }
                    }
                }
            }
        }
    }

    @media @mobile-sm {
        .f9tabs {
            .tabs {
                ul {
                    li {
                        font-size: 9px;
                    }
                }
            }
        }
    }

    body.user-is-tabbing {
        .f9tabs {
            .tabs {
                a:focus {
                    border: 4px solid #aaa;
                }
            }
        }
    }
</style>
